export default function useREM(multiple) {
    return `${multiple}rem`;
}
//# sourceMappingURL=useREM.web.js.map